import React, { Component } from 'react'
import Button from 'components/button/button'
import { connect } from 'react-redux'

import { 
	getCurrentAccount,
	getCurrentUser,
} from 'state/selectors'

import {
    saveProjectUpdate
} from 'state/actions'

import Textarea from 'react-textarea-autosize'

import ValidateResponse from 'components/validations/validate-response'
import withValidateResponse from 'components/validations/withValidateResponse'

import moment from 'moment'

class ModalProgressUpdate extends Component {
	state = {
        text: '',
        hasMounted: false
    }

    componentWillMount = _ => {
        if(this.props.data && this.props.data.text){
            this.setState({
                text: this.props.data.text
            })
        }
    }
    
    componentDidMount = _ => {
    	setTimeout(_ => { 
            this.setState({
                hasMounted: true
            }, _ => {
                window.requestAnimationFrame(_ => {
                    if(this.textInput){
                        this.textInput.focus()
                    }
                })
            })
		}, 1)
    }

	handleSubmit = _ => {
		const {
			isLoading,
			setLoading,
			handleSuccess,
			closeCallback,
            handleError,
            saveProjectUpdate,
            data
        } = this.props
        
        const {
            text
        } = this.state

		if(isLoading){
			return 
        }
        
        if(text == '' || !text || text == ' '){
            return handleError("You'll need to enter some feedback first!")
        }

        setLoading(true)

        saveProjectUpdate({
            ...data,
            text
        }, _ => {
            setLoading(false)
            closeCallback()
        })
	}

	updateText = _ => {
		this.setState({
			text: this.textInput.value
		})
	}

	render() {		
		const {
            data,
			userData,
            closeCallback,
            handleDismiss,
            validateResponse
        } = this.props

        const {
            hasMounted,
            text
        } = this.state

        const {
            completedPercent,
            hoursEstimated,
            hoursTracked,
            overdueCount,
            created_at
        } = data

        const format = 'dddd, MMMM D'
        
        const title = created_at ? moment(created_at).format(format) : moment().format(format)

		return(
			<div>
				<div className={'borders modal-progress-update'}>
                    <div className="left">
                        <ul>
                            <li>
                                <label>
                                    Completion
                                </label>
                                <span>
                                    { completedPercent }%
                                </span>
                            </li>
                            <li>
                                <label>
                                    Tasks overdue
                                </label>
                                <span>
                                    { overdueCount }
                                </span>
                            </li>
                            { (hoursEstimated || hoursTracked) ?
                                <li>
                                    <label>
                                        Hours
                                    </label>
                                    <span>
                                        { hoursTracked }/{hoursEstimated}
                                    </span>
                                </li>
                            : null }
                        </ul>
                    </div>
                    { hasMounted ?
                    <div className="right">
                        <h3>
                            { title }
                        </h3>
                        { created_at ?
                            <p>
                                { text }
                            </p>
                            :
                            <Textarea
                                inputRef={ref => {this.textInput = ref}}
                                onChange={this.updateText} 
                                placeholder="How are things tracking?"
                                value={text}
                            />
                        }
                        <ValidateResponse 
                            dismissCallback={handleDismiss} 
                            response={validateResponse} 
                        />
                    </div>
                    : null }
				</div>
                { !created_at ?
                    <Button 
                        size={'big'} 
                        level={'high'} 
                        callback={this.handleSubmit} 
                        label={'Submit'} 
                        icon={'check'}
                    />
                : null }
				<Button 
					size={'big'} 
					level={'low'} 
					callback={closeCallback} 
					label={'Cancel'} 
				/>
			</div>
		);
	}
}

const mapStateToProps = state => {  
  return {
    accountData: getCurrentAccount(state),
	userData: getCurrentUser(state),
  }
}

const ModalProgressUpdateWithValidateResponse = withValidateResponse(ModalProgressUpdate)

export default connect(mapStateToProps, {
    saveProjectUpdate
})(ModalProgressUpdateWithValidateResponse)



// WEBPACK FOOTER //
// ./src/components/modal/modal-types/modal-progress-update.jsx